import React,{Component} from "react";
import "./index.scss";
import appinfo from "../../clientsJSON";

export default class Team extends Component {
    render(){

        return(
    <div style={{marginTop:70}}>
         <h1 style={{textAlign:"center"}}>{appinfo.team.title1}</h1>
        <div className="mpteamstart">
         <div className="mpteambody">
         <div className="wrapper">
        
       {appinfo.team.title1_description.map(i=>{return(
           <div>
       <div className="membre">
            <img className="teamimage"src={i.image} alt="" />
           
            {/* <div className="info">
               <h5 className="name">{i.name}</h5>
               <p className="job">{i.position}</p>
            </div> */}
           <div className="overly top">
               <div className="middle">
            <h5 className="name">{i.name}</h5>
               <p className="job">{i.position}</p>
            <p className="teamtext"><a href={i.aboutmelink}>{i.aboutme}</a>
            </p>
               
            <div className="social-icones">
                {i.icons.map(i=>{
                    return(
                    <a href={i.link} className="icon"><i className={i.type} aria-hidden="true"></i></a>)})}
            </div>
        </div>
        </div>
        
       </div><h1 style={{lineHeight:0.8}}>{i.name}</h1>
            <p style={{lineHeight:1.3}}>{i.position}</p></div>)})}
    </div>
    </div>
    </div>

    <h1 style={{textAlign:"center"}}>{appinfo.team.title2}</h1>
        <div className="mpteamstart">
         <div className="mpteambody">
         <div className="wrapper">
        
       {appinfo.team.title2_description.map(i=>{return(
    <div>
       <div className="membre">
            <img className="teamimage"src={i.image} alt="" />
           
            {/* <div className="info">
               <h5 className="name">{i.name}</h5>
               <p className="job">{i.position}</p>
            </div> */}

           <div className="overly top">
               <div className="middle">
            <h5 className="name">{i.name}</h5>
               <p className="job">{i.position}</p>
            <p className="teamtext"><a href={i.aboutmelink}>{i.aboutme}</a>
            </p>
               
            <div className="social-icones">
                {i.icons.map(i=>{
                    return(
                    <a href={i.link} className="icon"><i className={i.type} aria-hidden="true"></i></a>)})}
            </div>
        </div>
        </div>
       </div>
       <h1 style={{lineHeight:1.3}}>{i.name}</h1>
        <p style={{lineHeight:1.3}}>{i.position}</p>
    </div>)})}
    </div>
    </div>
    </div>





</div>

           
        )
    }
}